export class EmployeeDirectDeposit {
  Id: number;
  AccountType: string;
  RoutingNumber: string;
  AccountNumber: string;
  CalculationMethod: number;
  Amount: number;
  DateAdded: Date;
  IsActive: boolean;
  IsPrenote: boolean;
  PrenoteExpireDate: Date;
  IntegrityHash: string;
  DateActive: Date;
}

export class EmployeeDirectDepositExtended extends EmployeeDirectDeposit {
  BankName: string;
}

export enum DirectDepositTypes {
  Checking = 0,
  Savings = 1,
  IRA = 2
}
